import { useState } from "react";
import { ChevronDown, ChevronUp, Search } from "react-feather";
import { Card, CardBody, CardHeader, Col, Collapse, Input } from "reactstrap";
import { Btn, H5 } from "../../../../../../AbstractElements";
import { Filter, FindCourse } from "../../../../../../Constants/Constants";
import CheckboxLists from "./CheckboxLists";

const FindCourseCard = () => {
  const [isFilter, setIsFilter] = useState(true);
  return (
    <Col xl="12">
      <Card>
        <CardHeader>
          <H5 className="mb-0">
            <Btn color="transparent" className="btn-link d-flex align-items-center gap-2 justify-content-between" onClick={() => setIsFilter(!isFilter)}>
              {FindCourse} {isFilter ? <ChevronDown /> : <ChevronUp />}
            </Btn>
          </H5>
        </CardHeader>
        <Collapse isOpen={isFilter}>
          <CardBody className="filter-cards-view animate-chk">
            <div className="job-filter">
              <div className="faq-form">
                <Input type="text" placeholder="Search.." />
                <Search className="search-icon" />
              </div>
            </div>
            <CheckboxLists />
            <Btn color="primary" className="text-center">{Filter}</Btn>
          </CardBody>
        </Collapse>
      </Card>
    </Col>
  );
};
export default FindCourseCard;
